import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Button, Form } from "antd";
import { usePDF, Margin } from 'react-to-pdf';
import ProgressModal from '../../../App/Utils/ProgressModal'
import GeneralDetails from "../Components/GeneralDetails";
import Progress from "../RequestFeedback/Components/Progress";
import SafetyFeedback from "../Components/SafetyFeedback";
import { ArrowRightOutlined, ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import QualityFeedback from "../Components/QualityFeedback";
import ScheduleFeedback from "../Components/ScheduleFeedback";
import DisciplineFeedback from "../Components/DisciplineFeedback";
import ImprovementFeedback from "../Components/ImprovementFeedback";
import { DataProvider } from "../../DataProvider";
import './ViewFeedback.css'
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";

const ViewFeedback = (props) => {
    const dataProvider = new DataProvider();
    const formRef = useRef();
    const { toPDF, targetRef } = usePDF({
        filename: 'page.pdf',
        page: {
            margin: Margin.SMALL,
           format: 'A2',
        },
    });

    const [state, setState] = useState({
        dropdownValues: {
        },
        initialValues: {},
        routeName: props.location.pathname.split("/").pop(),
        showProgress: true,
    });

    useEffect(() => {
        dataProvider.getFeedback(state.routeName)
            .then(response => {
                if (response.ok) {
                    response.json().then(responseJson => {
                        responseJson['data']['evaluation_period'] = moment(responseJson['data']['evaluation_period'], 'YYYY-MM-DD')
                        setState({ ...state, initialValues: responseJson['data'], showProgress: false })
                        openNotification("success", "Success", responseJson["message"])
                    })
                } else {
                    setState({ ...state, showProgress: false })
                    response.json().then(responseJson => {
                        openNotification("error", "Error", responseJson["message"])
                    })
                }
            }).catch(error => {
                setState({ ...state, showProgress: false })
                openNotification("error", "Error", "Error connecting server")
            })

    }, [])



    return (
        <>
            {state.showProgress ?
                <ProgressModal showProgress={state.showProgress} /> : <>
                    <div className="form-box" style={{ padding: "10px" }}>
                        <Button onClick={() => props.history.replace('/AllFeedback')}>Back</Button>
                        <Button type={'primary'} 
                            onClick={() => {
                                openNotification("warning", "Export to PDF", "Please wait, file will download shortly")
                                toPDF()
                            }} 
                            style={{float:"right"}}>
                                Download Report
                        </Button>
                    </div>
                    <div ref={targetRef}>
                    <Form
                        className="ant-form ant-form-vertical"
                        initialValues={state.initialValues}
                        ref={formRef}
                    >
                        <div className="row form-box">
                            <legend className="form-legend">General Details</legend>
                            <GeneralDetails
                                initialValues={state.initialValues}
                                formRef={formRef}
                                disabled={true} />
                        </div>
                        <div className="row">

                            <div className="col-lg-12 col-md-12" >
                                <SafetyFeedback
                                    ref={formRef}
                                    initialValues={state.initialValues}
                                    disabled={true} />
                            </div>
                            <div className="col-lg-12 col-md-12" >
                                <QualityFeedback
                                    initialValues={state.initialValues}
                                    disabled={true} />
                            </div>
                            <div className="col-lg-12 col-md-12" >
                                <ScheduleFeedback
                                    initialValues={state.initialValues}
                                    disabled={true} />
                            </div>
                            <div className="col-lg-12 col-md-12" >
                                <DisciplineFeedback
                                    initialValues={state.initialValues}
                                    disabled={true} />
                            </div>
                            <div className="col-lg-12 col-md-12" >
                                <ImprovementFeedback
                                    initialValues={state.initialValues}
                                    disabled={true} />
                            </div>
                        </div >
                    </Form ></div></>}
        </>

    );
};

export default ViewFeedback;
